import { Option } from '@webapp/types/common/option';
import { ReleaseArtistRole } from '@common/types/release/release-artist-role';
import { FUGA_CONTRIBUTOR_ROLE } from '@services/publisher/types/FugaContributorRole';

export const COLLABORATOR_ROLES: Option<ReleaseArtistRole>[] = [
  { label: 'Main', value: 'main' },
  { label: 'Feat.', value: 'featuring' },
];

export const CONTRIBUTOR_ROLES: Option[] = FUGA_CONTRIBUTOR_ROLE.map((r) => ({
  value: r,
  label: r,
}));

export const fieldToStepIndexMap: { [key: string]: number } = {
  title: 1,
  cover: 1,
  track: 1,
  artists: 2,
  recordLabel: 2,
  genres: 2,
  releaseDate: 3,
  releaseHistory: 3,
  preorderDate: 3,
  stores: 3,
  isStoreMaximizer: 3,
  hasYoutubeContentID: 3,
  removeBranding: 3,
  regions: 3,
  type: 3,
  UPCEAN: 3,
  trackName: 4,
  trackVersion: 4,
  instrumental: 4,
  isExplicit: 4,
  lyrics: 4,
  language: 4,
  isrc: 4,
  split: 4,
  copyrightDocuments: 4,
  hasAppleMusic: 11,
  src: 21,
  isInstantGratification: 22,
  previewStart: 4,
  ownProduced: 4,
  paidItems: 4,
};

export const releaseStepNameFromIndexMap: { [key: number]: string } = {
  1: 'Cover Art + Music',
  2: 'Names + genres',
  3: 'Distribution Options',
  4: 'Tracklist',
};

export const fieldToIndexMap: { [key: string]: number } = {
  title: 1,
  cover: 2,
  track: 3,
  artists: 4,
  recordLabel: 5,
  genres: 6,
  releaseDate: 7,
  releaseHistory: 8,
  preorderDate: 9,
  stores: 10,
  isStoreMaximizer: 11,
  hasYoutubeContentID: 12,
  hasAppleMusic: 11,
  removeBranding: 13,
  regions: 14,
  UPCEAN: 15,
  trackName: 16,
  trackVersion: 17,
  type: 18,
  isExplicit: 19,
  lyrics: 20,
  language: 21,
  isrc: 22,
  src: 23,
  isInstantGratification: 24,
  split: 25,
  previewStart: 26,
  ownProduced: 27,
};
